import { useRef, useState } from "react";

import styled from "styled-components/macro";

import { usePaymentForm } from "Payments/PaymentPage/PaymentFormScreen/PaymentFormContext";
import { motion } from "framer-motion";

import {
  SharedResizingChild,
  SharedResizingContainer,
} from "UI/SharedResizingArea";

import RequestCode from "./RequestCode";
import VerifyCode from "./VerifyCode";

export default function LoginForm() {
  const [hasAnimatedIn, setHasAnimatedIn] = useState(false);
  const [hasAnimatedToVerify, setHasAnimatedToVerify] = useState(false);
  const wrapperRef = useRef();

  const {
    state: { formStages },
  } = usePaymentForm();

  return (
    <Wrapper
      ref={wrapperRef}
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: "auto", opacity: 1 }}
      exit={{
        height: 0,
        opacity: 0,
        overflow: "hidden",
        transition: { type: "tween" },
      }}
      onAnimationComplete={() => setHasAnimatedIn(true)}
    >
      {hasAnimatedIn ? (
        <SharedResizingContainer
          bounce
          forceWidthWrapper={wrapperRef}
          direction={formStages.auth === "verifyCode" ? "left" : "right"}
        >
          {["verifyCode", "skipped", "isFullyLoggedIn"].includes(
            formStages.auth
          ) ? (
            <SharedResizingChild
              key="verify"
              onAnimationComplete={() => setHasAnimatedToVerify(true)}
              cancelExit={["skipped", "isFullyLoggedIn"].includes(
                formStages.auth
              )}
            >
              <VerifyCode
                hasAnimatedIn={hasAnimatedToVerify}
                resetHasAnimatedIn={() => setHasAnimatedToVerify(false)}
              />
            </SharedResizingChild>
          ) : (
            <SharedResizingChild key="request">
              <RequestCode />
            </SharedResizingChild>
          )}
        </SharedResizingContainer>
      ) : (
        <RequestCode />
      )}
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  width: 100%;
  position: relative;
`;
